const LOGIN_ERROR = {
  INVALID_TOKEN: 'invalid_token',
  INVALID_GRANT: 'invalid_grant',
  ERROR_TOKEN: 401,
  SESSION_TIMEOUT: 'Session expired. Please log in.',
  ACCESS_DENIED: "user doesn't have permission to access Gateway",
};
const NETWORK_ERROR = {
  INTERNAL_SERVER_ERROR: 'An error has occurred. Please try again later.',
  SAVE_PROJECT_SETTING_ERROR:
    'Clients can not be added at this time. Please try again later.',
  SAVE_CLIENT_ERROR:
    'Client information is not saved successfully due to IAM server error. Please try again later!',
  ERR_BAD_RESPONSE: 'ERR_BAD_RESPONSE',
};
const ERROR_CODE = {
  ACCESS_ERROR: 401,
  NETWORK_ERROR: 'Network Error',
};

const COMMON_SERVICE_ERROR = {
  DUPLICATE: 'Oops! Please do not add the same person repeatedly.',
};
export { LOGIN_ERROR, NETWORK_ERROR, ERROR_CODE, COMMON_SERVICE_ERROR };
